import React from 'react'
import './description-point.scss'

import zone1 from '../../../assets/images/model/zonas.png'
import zone2 from '../../../assets/images/model/canales.png'
import zone3 from '../../../assets/images/model/alas.png'
import zone4 from '../../../assets/images/model/zona-v.png'

const DescriptionPoint = ({ zone = -1, setZone }) => {

  const txtZones = [
    {
      txt: '3 Zonas de absorción inteligente',
      img: zone1,
    },
    {
      txt: 'Canales que distribuyen el flujo',
      img: zone2,
    },
    {
      txt: 'Alas asimétricas',
      img: zone3,
    },
    {
      txt: 'Se adapta a tu Zona V',
      img: zone4,
    },


  ]

  return (
    <div className={`f-description-point ${zone === -1 ? 'opacity' : ''}`}>
      {zone !== -1 && (
        <>
          <span className='f-description-point__close' onClick={() => setZone(-1)} />
          <img src={txtZones[zone].img} alt={txtZones[zone].txt} />
          <p>{txtZones[zone].txt}</p>
        </>

      )}
    </div>
  )
}

export default DescriptionPoint
